import { __extends } from "tslib";
import { axiosInstance } from '@/setup/axios/AxiosConfig';
import BaseRepository from '@/core/standard/BaseRepository';

var UnitService =
/** @class */
function (_super) {
  __extends(UnitService, _super);

  function UnitService() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.collection = 'units';
    _this.version = 'v1';
    return _this;
  }

  return UnitService;
}(BaseRepository);

export default new UnitService(axiosInstance);